import { useCallback, useState } from 'react';
import useIsomorphicLayoutEffect from './useIsomorphicLayoutEffect';
import type { FlowProviderContextType } from '../util/react-transition-component/components/FlowProvider';
import { useFlowProviderContext } from '../util/react-transition-component/components/FlowProvider';

function useSitePreloadReleaseFlow(): {
  isPreloaded: boolean | undefined;
  removePreloader: boolean | undefined;
  onPreloadComplete: () => void;
  onPreloaderTransitionOutStart: () => void;
  onPreloaderTransitionOutComplete: () => void;
} {
  const { hijackFlow, releaseHijackFlow } = useFlowProviderContext() as FlowProviderContextType;
  const [removePreloader, setRemovePreloader] = useState<boolean>();
  const [isPreloaded, setIsPreloaded] = useState<boolean>(false);

  useIsomorphicLayoutEffect(() => {
    hijackFlow();
  }, []);

  useIsomorphicLayoutEffect(() => {
    if (typeof window !== 'undefined') {
      setIsPreloaded(false);
    }
  }, []);

  const onPreloadComplete = useCallback(() => {
    setIsPreloaded(true);
  }, []);

  const onPreloaderTransitionOutStart = useCallback(() => {}, []);

  const onPreloaderTransitionOutComplete = useCallback(() => {
    setRemovePreloader(true);
    releaseHijackFlow();
  }, [releaseHijackFlow]);

  return {
    isPreloaded,
    removePreloader,
    onPreloadComplete,
    onPreloaderTransitionOutStart,
    onPreloaderTransitionOutComplete,
  };
}

export default useSitePreloadReleaseFlow;
